import { defineMessages } from 'react-intl';

export const translations = defineMessages({
    hobbiesNamePlaceholder: {
        id: 'Gifs.Dialog.hobbies.name.placeholder',
        defaultMessage: 'ex : Boat, Guitar...'
    }
});
